// @flow
import { useEffect, useContext, useRef } from 'react';
import forEachObjIndexed from 'ramda/es/forEachObjIndexed';

import { places } from './places';
import BannersContext from './banners-context';


type Props = {
  pathname: string,
}

const BannerRefresher = ({ pathname }: Props) => {
  const skippedFirstRefresh = useRef(false);

  const {
    effects: {
      refreshBannerByPlaceId,
    },
  } = useContext(BannersContext);

  useEffect(() => {
    if (!skippedFirstRefresh.current) {
      skippedFirstRefresh.current = true;
      return;
    }
    forEachObjIndexed(({ placeId }) => {
      refreshBannerByPlaceId(placeId);
    }, places);
  }, [pathname]);

  return null;
};

export default BannerRefresher;
